import React from "react";

export default function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center w-full">
      <div className="relative">
        <svg
          width="180"
          height="44"
          viewBox="0 0 293 71"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="z-10 relative"
        >
          <g clipPath="url(#clip0_2_522)">
            <g filter="url(#filter0_d_2_522)">
              <path
                d="M93.4545 6.07585C93.0491 6.07585 92.6682 5.98925 92.2996 5.8408C91.9433 5.69234 91.6238 5.46966 91.3535 5.18513C91.0832 4.90059 90.8621 4.57894 90.7146 4.22018C90.5549 3.84905 90.4812 3.45317 90.4812 3.03255C90.4812 2.61194 90.5549 2.22843 90.7146 1.84493C90.8621 1.48616 91.0832 1.16451 91.3535 0.879978C91.6238 0.595443 91.9433 0.385134 92.2996 0.224309C92.6682 0.0634845 93.0614 -0.0107422 93.4545 -0.0107422C93.8477 -0.0107422 94.2409 0.0758557 94.6095 0.224309C94.9658 0.372763 95.2852 0.595443 95.5555 0.879978C95.8258 1.16451 96.047 1.48616 96.1944 1.84493C96.3542 2.21606 96.4279 2.61194 96.4279 3.03255C96.4279 3.45317 96.3542 3.83668 96.1944 4.22018C96.047 4.57894 95.8258 4.90059 95.5555 5.18513C95.2852 5.46966 94.9658 5.67997 94.6095 5.8408C94.2409 6.00162 93.8477 6.07585 93.4545 6.07585ZM93.4545 0.286165C91.9679 0.286165 90.7638 1.52328 90.7638 3.04492C90.7638 4.56657 91.9679 5.80368 93.4545 5.80368C94.9412 5.80368 96.1453 4.56657 96.1453 3.04492C96.1453 1.52328 94.9412 0.286165 93.4545 0.286165Z"
                fill="#D4AF37"
              />
              <path
                d="M94.0075 3.27998C94.0075 3.27998 94.1181 3.24286 94.1672 3.21812C94.3024 3.14389 94.413 3.03255 94.4867 2.89647C94.5604 2.76039 94.5972 2.59956 94.5972 2.414C94.5972 2.22843 94.5604 2.06761 94.4867 1.93152C94.413 1.79544 94.3024 1.6841 94.1672 1.60988C94.0321 1.53565 93.8723 1.49854 93.688 1.49854H92.4348V4.69028H92.8771V3.34183H93.5406L94.2164 4.69028H94.7447L94.0075 3.29235V3.27998ZM92.8649 1.91915H93.7003C93.7863 1.91915 93.8601 1.9439 93.9215 1.98101C93.9829 2.01812 94.0321 2.07998 94.0689 2.1542C94.1058 2.22843 94.1181 2.31503 94.1181 2.414C94.1181 2.51297 94.1058 2.59956 94.0689 2.67379C94.0321 2.74802 93.9829 2.80987 93.9215 2.84699C93.8601 2.8841 93.7863 2.90884 93.7003 2.90884H92.8649V1.91915Z"
                fill="#D4AF37"
              />
              <path
                d="M50.6606 9.57697L12.8181 19.7831L14.6365 26.6244C15.8775 26.6739 17.0938 26.8842 18.2611 27.2429C22.9054 28.6532 26.7511 32.3893 28.0903 37.4491C29.7735 43.7707 27.0459 50.278 21.7996 53.5934L23.618 60.4346L50.6483 53.148V62.08L17.573 70.9996L11.4912 48.1254L15.6317 47.012C18.8017 46.1584 20.6815 42.8677 19.8337 39.6883C18.986 36.4965 15.7178 34.6037 12.5601 35.4573L8.41956 36.5707L6.76088 30.3604L4.5493 22.0347L2.32544 13.7089L50.6606 0.64502V9.57697Z"
                fill="#D4AF37"
              />
              <path
                d="M101.392 57.3045L50.6605 70.987V62.0674L90.9112 51.2055L89.0928 44.3643C87.8518 44.3148 86.6232 44.1045 85.456 43.7457C80.8117 42.3354 76.9783 38.5994 75.6267 33.5396C73.9435 27.2056 76.6711 20.7107 81.9174 17.3953L80.099 10.554L50.6605 18.4963V9.57671L86.144 0.00146484L92.2258 22.8757L88.0853 23.9891C84.9154 24.8427 83.0355 28.1334 83.8833 31.3128C84.7311 34.5045 87.9993 36.3973 91.1569 35.5437L95.2975 34.4303L96.9561 40.6406L99.1677 48.9664L101.379 57.2921L101.392 57.3045Z"
                fill="#D4AF37"
              />
            </g>
            <path
              d="M147.466 14.254L147.011 16.889C146.188 21.6148 144.1 25.3138 140.721 27.9859C137.342 30.6704 133.3 32.0065 128.569 32.0065C123.839 32.0065 119.871 30.4107 117.192 27.2189C114.514 24.0272 113.568 20.1426 114.354 15.5653C115.14 11.0499 117.303 7.32614 120.829 4.39419C124.355 1.46223 128.483 0.00244141 133.201 0.00244141C136.347 0.00244141 139.062 0.64574 141.335 1.93234C143.608 3.21893 145.328 5.03749 146.508 7.388L139.836 10.7777C138.386 8.16738 135.917 6.86841 132.427 6.86841C129.675 6.86841 127.304 7.70965 125.326 9.37975C123.348 11.0499 122.107 13.2643 121.627 16.023C121.111 18.7818 121.554 20.9962 122.967 22.6663C124.38 24.3364 126.481 25.1777 129.307 25.1777C133.853 25.1777 136.949 23.5942 138.62 20.4272H130.449L131.543 14.2663H147.478L147.466 14.254Z"
              fill="#D1D3D4"
            />
            <path
              d="M163.721 32.0056C159.114 32.0056 155.465 30.3973 152.749 27.1684C150.034 23.9396 149.112 20.0798 149.96 15.5643C150.783 10.987 152.946 7.25094 156.472 4.3561C159.998 1.44889 164.225 0.00146484 169.164 0.00146484C173.71 0.00146484 177.335 1.60971 180.038 4.83857C182.753 8.06743 183.699 11.9272 182.876 16.4427C182.028 21.02 179.853 24.7561 176.339 27.6509C172.825 30.5581 168.623 32.0056 163.709 32.0056H163.721ZM164.495 25.152C167.161 25.152 169.557 24.2983 171.695 22.6035C173.833 20.9087 175.135 18.7066 175.627 16.0097C176.106 13.3128 175.627 11.1107 174.202 9.41589C172.764 7.72104 170.724 6.86744 168.095 6.86744C165.466 6.86744 163.119 7.72104 161.055 9.41589C158.991 11.1107 157.725 13.3128 157.234 16.0097C156.755 18.7313 157.185 20.9458 158.548 22.6282C159.912 24.3107 161.89 25.152 164.495 25.152Z"
              fill="#D1D3D4"
            />
            <path
              d="M192.73 24.9664H204.082L202.854 32.0056H184.252L185.493 24.9293L189.867 0.00146484H197.104L192.73 24.9664Z"
              fill="#D1D3D4"
            />
            <path
              d="M224.392 0.00146484C228.569 0.00146484 231.924 1.62208 234.455 4.85094C236.986 8.07981 237.858 11.952 237.072 16.4674C236.285 21.0076 234.197 24.7313 230.806 27.6509C227.415 30.5581 223.421 32.0179 218.814 32.0179H206.061L211.675 0.013836H224.392V0.00146484ZM230.032 15.7746C230.511 13.0654 230.118 10.9252 228.852 9.37877C227.574 7.82001 225.67 7.04063 223.127 7.04063H217.671L214.514 24.9664H219.527C222.217 24.9664 224.527 24.1251 226.432 22.455C228.336 20.7726 229.54 18.5581 230.019 15.7746H230.032Z"
              fill="#D1D3D4"
            />
            <path
              d="M262.505 7.0408H250.009L249.063 12.3851H260.465L259.237 19.2387H247.859L246.852 24.9542H259.568L258.34 31.9933H238.374L243.989 -0.0107422H263.709L262.48 7.02842L262.505 7.0408Z"
              fill="#D1D3D4"
            />
            <path
              d="M262.456 32.0056L268.12 0.00146484H273.55L282.655 17.9767L285.763 0.00146484H293L287.434 32.0056H281.979L272.899 14.0303L269.692 32.0056H262.456Z"
              fill="#D1D3D4"
            />
            <path
              d="M137.723 38.9829L137.047 43.0035H127.648L122.758 70.987H118.556L123.446 43.0035H114.096L114.772 38.9829H137.723Z"
              fill="#D1D3D4"
            />
            <path
              d="M141.925 38.9829H146.127L140.512 70.9994H136.31L141.925 38.9829Z"
              fill="#D1D3D4"
            />
            <path
              d="M162.296 70.987C157.48 70.987 153.781 69.3664 151.189 66.1375C148.596 62.9087 147.712 59.0365 148.535 54.5458C149.321 50.0798 151.496 46.3685 155.071 43.4118C158.647 40.4551 162.701 38.9829 167.247 38.9829C170.331 38.9829 172.997 39.6633 175.221 41.0118C177.445 42.3602 179.104 44.2159 180.197 46.5664L176.425 48.5087C174.644 44.8097 171.511 42.954 167.026 42.954C163.426 42.954 160.281 44.1046 157.602 46.3932C154.924 48.6819 153.278 51.552 152.676 54.9911C152.074 58.4551 152.7 61.3252 154.555 63.5891C156.423 65.853 159.114 66.9788 162.665 66.9788C164.962 66.9788 167.088 66.4839 169.017 65.4818C170.958 64.4798 172.555 63.0818 173.833 61.288L177.335 63.453C175.615 65.7788 173.415 67.6097 170.774 68.9705C168.12 70.319 165.306 70.9994 162.308 70.9994L162.296 70.987Z"
              fill="#D1D3D4"
            />
            <path
              d="M209.255 38.9831L192.177 54.7562L203.898 70.9872H199.18L187.79 55.214L185.026 70.9872H180.824L186.439 38.9707H190.641L188.122 53.3707L203.91 38.9707H209.267L209.255 38.9831Z"
              fill="#D1D3D4"
            />
            <path
              d="M231.272 43.0035H216.737L215.005 52.8386H228.397L227.672 56.8221H214.305L212.511 66.9788H227.267L226.591 70.9994H207.609L213.248 38.9829H231.96L231.285 43.0035H231.285Z"
              fill="#D1D3D4"
            />
            <path
              d="M257.615 38.9829L256.939 43.0035H247.54L242.65 70.987H238.448L243.338 43.0035H233.988L234.664 38.9829H257.615Z"
              fill="#D1D3D4"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_2_522"
              x="-1.67456"
              y="-4.01074"
              width="107.066"
              height="79.0103"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.831373 0 0 0 0 0.686275 0 0 0 0 0.215686 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_2_522"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_2_522"
                result="shape"
              />
            </filter>
            <clipPath id="clip0_2_522">
              <rect width="293" height="71" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[220px] h-[220px]">
          <div className="w-full h-full border-[6px] border-transparent border-l-[#d9ac4f] border-r-[#d9ac4f] rounded-full animate-spin absolute"></div>
        </div>
      </div>
    </div>
  );
}
